import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { CONF2_QUERY_PARAMS } from "@youm-front/conf2/domain";
import { mergeMap } from "rxjs/operators";
import { Conf2Actions } from "../actions";
import { Conf2Selectors } from "../selectors";

@Injectable()
export class Conf2Effects {
  constructor(
    private readonly actions$: Actions,
    private readonly router: Router,
    private readonly store: Store
  ) {}

  conf2AccountSignIn$ = createEffect(() =>
    this.store
      .pipe(select(Conf2Selectors.conf2JwtQueryParam))
      .pipe(
        mergeMap((_) =>
          _ ? [Conf2Actions.conf2AccountSignIn({ jwt: _ })] : []
        )
      )
  );

  conf2JwtQueryParamDelete$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(Conf2Actions.conf2JwtQueryParamDelete),
        mergeMap(() =>
          this.router.navigate([], {
            queryParams: { [CONF2_QUERY_PARAMS.jwt]: null },
            queryParamsHandling: "merge"
          })
        )
      ),
    { dispatch: false }
  );
}
